/** MUI 主题创建与导出 —— 视觉对齐 docs/操作人员移动端 设计稿（token 见 tokens.ts） */

import { createTheme } from '@mui/material/styles';
import { palette } from './palette';
import { typography } from './typography';
import { T } from './tokens';

const theme = createTheme({
  palette,
  typography,
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: 'none',
          fontWeight: 600,
          padding: '8px 16px',
        },
        containedPrimary: {
          background: T.brandGrad,
          boxShadow: '0 6px 16px rgba(31,111,229,.30)',
          '&:hover': {
            background: T.brandGrad,
            boxShadow: '0 8px 20px rgba(31,111,229,.38)',
          },
          '&.Mui-disabled': {
            background: T.line,
            boxShadow: 'none',
          },
        },
        outlinedPrimary: {
          borderWidth: 1.5,
          borderColor: T.brandLine,
          '&:hover': { borderWidth: 1.5, backgroundColor: T.brandSoft },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 18,
          boxShadow: T.shadow,
          border: `1px solid ${T.line}`,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E3EAF4' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderWidth: 1.5 },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { borderRadius: 14 },
        standardInfo: { backgroundColor: T.brandSoft, color: T.ink2 },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: '#FAFBFC',
            fontWeight: 600,
            color: T.ink2,
            fontSize: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.3px',
            padding: '12px 16px',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${T.line}`,
          padding: '12px 16px',
          fontSize: '13px',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 600,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 18,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: 'none',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
        },
      },
    },
  },
});

export default theme;
